import { Component, Vue , Prop} from 'vue-property-decorator';

@Component
export default class extends Vue {
  @Prop({ required: false, default(){ return (this as any).$auth.user.companyId; } })
  public companyId!:number;
}
